import React from 'react';
import { Link, useLocation } from "react-router-dom";
import * as yup from "yup";
import { useState, useEffect } from 'react';
import { useUserContext } from '../../contexts/user-context';
import GQLChanges from '../../utils/graphql-changes';
import { useRecordModuleHistory } from '../../contexts/module-history-context';
import {
    CampaignsQueryDocument,
    Site, SitesQueryDocument,
    useCreateSiteMutationMutation,
    useGetAffectedBookingsMutation,
    useSitesMutationMutation,
    useUpdateSiteMutationMutation
} from '../../generated/graphql';
import { Button, Card } from "@mui/material";
import { FieldTableColumnProps } from "../../components/FieldTable/FieldTableTypes";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useSnackbar } from "notistack";
import { SideList } from "../../components/SideList";
import DigitalSearch from './search';

function blankValues() {
    return {
        name: '',
        panels: [],
        latitude: '',
        longitude: '',
        siteStructure: null,
        siteBuildAndRepairs: [],
        siteRentals: [],
        sitePlannings: [],
        siteHealthAndSafeties: [],
        siteDigitalBookingPricing: [],
        siteFilesOther: [],
        tags: [],
        tvArea: null
    };
}


const schema = yup.object().shape({
    name: yup.string().min(1),
    siteStructure: yup.object().required(),
    siteStructureType: yup.object().required(),
    sitePricing: yup.object().required(),
    region: yup.object().required(),
    distributor: yup.object().required(),
    subletter: yup.object().required()
});
const lookupColumns = ['region', 'region.regionType', 'posterSize', 'distributor',
    'sitePricing', 'panels.postInstruction', 'panels.pack',
    'siteStructure', 'siteStructureType', 'siteHealthAndSafeties.healthAndSafetyType',
    'sitePlannings.planningStage', 'sitePlannings.planningOutcome',
    'siteBuildAndRepairs.buildContractor', 'siteBuildAndRepairs.buildType', 'siteBuildAndRepairs.planningStage', 'siteBuildAndRepairs.planningOutcome',
    'siteRentals.rentalType', 'siteRentals.paymentMethod', 'siteRentals.paymentFrequency', 'subletter', 'borough', 'style', 'tvArea', 'tags'];


const modes = [
    {name: 'default', icon: 'list'},
    {
        name: 'image', icon: 'grid-view',
        // eslint-disable-next-line react/display-name
        render: function (values, callback) {
            return <div className="grid-view">{values.map((row) => {
                return <Link key={'img-' + row.id} to={{
                    pathname: '/sites/' + (row.id),
                    search: (location.search ? location.search : '')
                }}><Card onClick={callback}><img alt="" src={row.externalThumbnail} /><h3>{row.name}</h3></Card></Link>;
            })}</div>;
        }
    }
];

export function DigitalBookings() {
    const location = useLocation();
    const [affectedBookingsQuery] = useGetAffectedBookingsMutation();
    //    useMutation(getAffectedBookings);
    const [affectedBookings, setAffectedBookings] = useState([]);
    const [ignoreAffected, setIgnoreAffected] = useState(false);
    const [showRevenueReport, setShowRevenueReport] = useState(false);
    const [showPlanningReport, setShowPlanningReport] = useState(false);
    const createMutation = useCreateSiteMutationMutation();
    //useMutation(createSiteMutation);
    const updateMutation = useUpdateSiteMutationMutation();
    //useMutation(updateSiteMutation);
    const combinedMutation = useSitesMutationMutation();
    const userContext = useUserContext();
    const user = userContext.user;
    const recordModuleHistory = useRecordModuleHistory();
    useEffect(() => {
        recordModuleHistory('digital-bookings');
    }, [recordModuleHistory, location]);
    const columns: FieldTableColumnProps<Site>[] = [
        {
            accessor: 'name',
            header: 'Site Name',
            dataType: 'link',
            options: {
                renderViewer: ({ field, row }) => {
                    return (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between', 
                                width: '60%', 
                                paddingRight: '8px', 
                            }}
                        >
                            <Link
                                to={{
                                    pathname: `/digital-bookings/${row.id}`,
                                    search: location.search || '',
                                }}
                                style={{
                                    textDecoration: 'none',
                                    flexGrow: 1, 
                                }}
                            >
                                {row.name}
                            </Link>
                            <Button
                                size="small"
                                title="Open Site Preview"
                                startIcon={<OpenInNewIcon />}
                                onClick={() => window.open(`${row.externalLink}`, '_blank')}
                                style={{
                                    marginLeft: 'auto', 
                                }}
                            />
                        </div>
                    );
                },
            },
        }, {
            accessor: 'region.name',
            header: 'Region',
            dataType: 'default'
        }, {
            accessor: 'siteStructure.name',
            header: 'Structure',
            dataType: 'default'
        }
    ];
    const openRevenueReport = () => {
        setShowRevenueReport(true);
    };
    const closeRevenueReport = () => {
        setShowRevenueReport(false);
    };
    const openPlanningReport = () => {
        setShowPlanningReport(true);
    };
    const closePlanningReport = () => {
        setShowPlanningReport(false);
    };
    const searchForm = (args) => {
        return <DigitalSearch {...args} />;
    };


    return <SideList
        searchForm={searchForm}
        label="Digital Bookings"
        skipScroll={true}
        className="sites"
        simpleDelete={true}
        getResults={(e)=>e.sites}
        query={SitesQueryDocument}
        columns={columns}
        baseUrl="/digital-bookings/"
        modes={modes}
        isDigitalSearch={true}
    />;
}


